export function getJobTitleAndCompanyHeading({ title, company = "" }) {
  if (company === "") {
    return title;
  } else {
    return title + " - " + company;
  }
}
